//Extension of Mui's Checkbox, as its 'readOnly' functionality doesn't seem to work correctly.

import { Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
import { InfoIconToolTip } from "../../../yoello-lib/modules/components/UI/InfoIconToolTip/InfoIconToolTip";
import ICommonFormProps from "../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";

export interface IFormCheckboxInput extends ICommonFormProps {
    value: boolean;
    label: string;
    key: string;
    keyName: string;
    readOnly?: boolean;
    tooltipContent?: React.ReactNode;
    onChange: (e: any, checked: boolean) => void;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        alignItems: "center"
    },
    readOnlyBox: {
        cursor: "default",
        "&.Mui-checked svg": {
            fill: "#000"
        }
    },
    readOnlyLabel: {
        cursor: "default"
    },
    disabledLabel: {
        color: "rgba(0, 0, 0, 0.38)",
    },
    disabledBox: {
        opacity: "0.25",
        "&.Mui-checked svg": {
            fill: "#000"
        }
    }
})


const FormCheckboxInput = ({
    value,
    label,
    key,
    keyName,
    readOnly,
    onChange,
    tooltipContent,
    ...props
}: IFormCheckboxInput ) => {

    const classes = useStyles();

    const _onChange = (event: React.ChangeEvent<{}>, checked: boolean) => {
        if(readOnly || props.disabled) return;
        onChange(event, checked);
    }

    return (
        <div className={classes.root}>
            <FormControlLabel 
                label={label} 
                key={key}
                onChange={_onChange}
                className={`${readOnly ? classes.readOnlyLabel : ""} ${props.disabled ? classes.disabledLabel : ""}`}
                control={
                    <Checkbox
                        {...props.register!(keyName)}
                        checked={value}
                        name={keyName}
                        color={"primary"}
                        onChange={_onChange}
                        disableRipple={readOnly}
                        className={`${readOnly ? classes.readOnlyBox : ""} ${props.disabled ? classes.disabledBox : ""}`}
                    />
                }
            />
            {
                tooltipContent && (
                    <div style={{paddingTop: "6px"}}>
                        <InfoIconToolTip infoComponent={tooltipContent}/>
                    </div>
                )
            }
        </div>
    )
}

export default FormCheckboxInput;